import React, { useEffect } from 'react';
import ClientSearch from './ClientSearch';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from '@tanstack/react-router';
import { actions } from './Clients.redux';
import DashboardCard from 'components/DashboardCard/DashboardCard';
import NumberedDataGridPagination from 'components/NumberedDataGridPagination';
import { Add, People } from '@mui/icons-material';
import { Button, Grid as MUIGrid } from '@mui/material';
import ClientAddModal from './ClientAddModal';
import ClientCell from './ClientCell';

const Clients = () => {
    const navigate = useNavigate();
    const clientList = useSelector((state) => state.clients.clients);
    const loading = useSelector((state) => state.clients.loading);
    const dispatch = useDispatch();
    const handleSearch = () => dispatch(actions.search());
    const showAddNew = () => dispatch(actions.showAddNew());
    const resetAll = () => dispatch(actions.resetAll());

    const columns = [
        { field: 'client_name', headerName: 'Name', flex: 1, minWidth: 180, sortable: false },
        { field: 'client_external_id', headerName: 'External ID', flex: 1, minWidth: 150, sortable: false },
        { field: 'last_visit', headerName: 'Last Visit', flex: 1, minWidth: 150, sortable: false },
        { field: 'address_city', headerName: 'City', flex: 1, minWidth: 140, sortable: false },
        { field: 'address_state', headerName: 'State', flex: 1, minWidth: 120, sortable: false },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => <ClientCell {...params} />,
        },
    ];

    useEffect(() => {
        handleSearch();
        return () => {
            resetAll();
        };
    }, []);

    return (
        <MUIGrid container spacing={4}>
            <MUIGrid size={{ xs: 12, lg: 3, xl: 4 }}>
                <ClientSearch />
            </MUIGrid>

            <MUIGrid size={{ xs: 12, lg: 9, xl: 8 }}>
                <DashboardCard
                    color={'deepOrange'}
                    icon={<People />}
                    topContent={'Clients'}
                    topLabel={
                        <>
                            <div>Click a client to view their profile or</div>
                            <div>
                                <Button variant="contained" size="small" color="primary" onClick={showAddNew}>
                                    <Add /> Add New
                                </Button>
                            </div>
                        </>
                    }
                    size="xl"
                >
                    <div style={{ width: '100%' }}>
                        <DataGrid
                            rows={clientList}
                            columns={columns}
                            getRowId={(row) => row.client_id}
                            pagination
                            pageSizeOptions={[5, 10, 20, 50]}
                            initialState={{
                                pagination: {
                                    paginationModel: { page: 0, pageSize: 10 },
                                },
                            }}
                            loading={loading}
                            disableRowSelectionOnClick
                            disableColumnMenu
                            disableCellFocus
                            sx={{
                                '& .MuiDataGrid-row': { cursor: 'pointer' },
                                '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
                                '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                                    outline: 'none',
                                },
                            }}
                            slots={{ pagination: NumberedDataGridPagination }}
                            onRowClick={(params) => {
                                if (params.field !== 'actions') {
                                    navigate({ to: `/clients/view/${params.row.client_id}` });
                                }
                            }}
                            autoHeight
                        />
                    </div>
                </DashboardCard>
            </MUIGrid>

            <ClientAddModal />
        </MUIGrid>
    );
};

export default Clients;
